const GAS_BRAND_STATUSES = {
  active: { name: "active", id: "active" },
  blocked: { name: "blocked", id: "blocked" },
  disabled: { name: "disabled", id: "disabled" },
  error: { name: "error", id: "error" },
};

export default GAS_BRAND_STATUSES;
